import { render, staticRenderFns } from "./CommercialTermsModal.vue?vue&type=template&id=f6e21c5a&scoped=true"
import script from "./CommercialTermsModal.vue?vue&type=script&lang=js"
export * from "./CommercialTermsModal.vue?vue&type=script&lang=js"
import style0 from "./CommercialTermsModal.vue?vue&type=style&index=0&id=f6e21c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e21c5a",
  null
  
)

export default component.exports